<template>
    <div class="l-inner">
        <app-section
            :title="page.title"
            titleClass="t-t2-heavy u-c-bright"
            :desc="page.desc"
            :push="page.push"
            :image="page.image"
            bgIntro="lighter"
            :btnReturn="btnReturn"
        >
            <template #content>
                <div class="p-economy__grid | l-grid">
                    <template v-for="(card, i) in page.body">
                        <card-economy
                            :key="`economy-card-${i}`"
                            v-if="card.slice_type === 'card'"
                            :bg="card.primary.bg"
                            :title="card.primary.title"
                            :desc="card.primary.desc"
                            :image="card.primary.image"
                            class="l-grid__item"
                        />
                        <card-economy
                            :key="`economy-card-${i}`"
                            v-else
                            bg="simple"
                            :title="card.primary.title"
                            :desc="card.primary.desc"
                            :website="card.primary.website"
                            :image="card.primary.image"
                            class="l-grid__item"
                        />
                    </template>
                </div>
            </template>
        </app-section>
        <about />
        <push :page="push" />
    </div>
</template>

<script>

import Push from 'layout/Push';
import About from 'layout/About';
import CardEconomy from 'objects/CardEconomy';
import AppSection from 'layout/AppSection';
import Icon from 'objects/Icon';
import AnimText from 'objects/AnimText';

import { mapState } from 'vuex'

export default {
    name: 'Economy',
    components: {
        Push,
        Icon,
        AnimText,
        About,
        CardEconomy,
        AppSection,
    },
    props: {
        page: Object,
    },
    computed: {
        ...mapState({
            currentPage: state => state.global.currentPage,
        }),

        btnReturn() {
            return {
                label: this.$t('btn.allEconomies'),
                path: '/economies'
            }
        },
        push() {
            const handle = this.$route.meta.prismicHandle
            return this.$store.getters['global/getNextRepeatable'](handle, this.currentPage.id)
        }
    }
};
</script>

<style lang="scss">

.p-economy {

    @media #{$breakpoint-horizontal} {

        .l-section__intro {
            min-width: 45em;
        }
    }
}

.p-economy__grid {

    @media #{$breakpoint-horizontal} {

        .c-card {

            &:nth-child(even) {
                margin-top: 0;
                margin-bottom: auto;
            }

            &:nth-child(odd) {
                margin-top: auto;
                margin-bottom: 0;
            }

            &.-simple {
                margin-top: auto;
                margin-bottom: auto;
            }
        }
    }
}

</style>
